import {DebounceSettings, debounce} from 'lodash-es';

export class EventSource {
    listeners: any = {};
    private index: number = 1;
    private uid2event: any = {};

    private getUid(): number {
        return this.index++;
    }

    public emit(event: string, ...args: any[]): void {
        // console.log(event, args);
        if (this.listeners.hasOwnProperty(event)) {
            for (let uid in this.listeners[event]) {
                if (this.listeners[event].hasOwnProperty(uid)) {
                    try {
                        this.listeners[event][uid].apply(this, args);
                    } catch (error) {
                        console.warn(error);
                    }
                }
            }
        }
    }

    public on(event: string, listener: Function): number {
        if (!this.listeners.hasOwnProperty(event)) {
            this.listeners[event] = {};
        }
        let uid: number = this.getUid();
        this.listeners[event][uid] = listener;
        this.uid2event[uid] = event;
        return uid;
    }

    // public batchedOn(
    //     event: string,
    //     listener: (...args: any) => any,
    //     delay: number = 250,
    //     settings?: DebounceSettings
    // ): number {
    //     const batch = [];
    //     const debounced = debounce(
    //         () => {
    //             listener(batch);
    //             batch.length = 0;
    //         },
    //         delay,
    //         settings
    //     );
    //     return this.on(event, (...args: any) => {
    //         batch.push(args);
    //         debounced();
    //     });
    // }

    // public debouncedOn(event: string, listener: (...args: any) => any, delay: number = 250): number {
    //     return this.on(event, debounce(listener, delay));
    // }

    public once(event: string, listener: Function): number {
        let uid: number = this.on(event, (data: any) => {
            listener(data);
            this.off(uid);
        });
        return uid;
    }

    off: (value: number) => void = (uid: number): void => {
        if (this.uid2event.hasOwnProperty(uid)) {
            let event: string = this.uid2event[uid];
            delete this.listeners[event][uid];
            delete this.uid2event[uid];
        }
    };

    destroy(): void {
        this.listeners = {};
    }
}
